import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, renderList as _renderList, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5864f90d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "file-btns" }
const _hoisted_3 = { class: "btns" }
const _hoisted_4 = { class: "inputs" }
const _hoisted_5 = { class: "tool-bar" }
const _hoisted_6 = { class: "tips-box" }
const _hoisted_7 = { class: "tips" }
const _hoisted_8 = { class: "price-info" }
const _hoisted_9 = { class: "price-label" }
const _hoisted_10 = { class: "price-num" }
const _hoisted_11 = { class: "gift" }
const _hoisted_12 = { style: {"flex":"auto"} }
const _hoisted_13 = { style: {"height":"500px","flex":"auto"} }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "pkg-col-box" }
const _hoisted_16 = { class: "pkg-text" }
const _hoisted_17 = { class: "pkg-text num" }
const _hoisted_18 = { class: "pkg-unit" }
const _hoisted_19 = { class: "pkg-text" }
const _hoisted_20 = { class: "pkg-text num" }
const _hoisted_21 = { class: "pkg-unit" }
const _hoisted_22 = { class: "promotion-label-container" }
const _hoisted_23 = {
  key: 0,
  class: "pre-promotion-label"
}
const _hoisted_24 = {
  key: 0,
  class: "promotion-label"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["title"]
const _hoisted_27 = { class: "promotion-card-scroll-container" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_30 = { class: "rule-name" }
const _hoisted_31 = {
  key: 0,
  class: "pre-promotion-label"
}
const _hoisted_32 = {
  key: 1,
  class: "promotion-label"
}
const _hoisted_33 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_34 = {
  key: 0,
  class: "plan-name"
}
const _hoisted_35 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { style: {"color":"red"} }
const _hoisted_39 = { style: {"color":"red"} }
const _hoisted_40 = { style: {"display":"flex","margin":"20px 0"} }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "报错信息", -1))
const _hoisted_42 = { class: "overflow-y-auto" }
const _hoisted_43 = {
  key: 0,
  class: "num-tip"
}
const _hoisted_44 = { style: {"margin-left":"5px"} }
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "gift-content" }
const _hoisted_47 = { class: "gift-title" }
const _hoisted_48 = { class: "unit" }
const _hoisted_49 = { class: "factory-price" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "value-symbol" }, "¥", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "value" }, "0.00", -1))
const _hoisted_52 = { class: "line-value" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "将", -1))
const _hoisted_54 = { style: {"width":"300px"} }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "修改为", -1))
const _hoisted_56 = { style: {"width":"300px"} }
const _hoisted_57 = { class: "operation-col" }
const _hoisted_58 = { class: "edit-row" }
const _hoisted_59 = { class: "description-container" }
const _hoisted_60 = {
  class: "description-item",
  style: {"width":"300px"}
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description-label" }, "ERP商品编码", -1))
const _hoisted_62 = { class: "description-content bg-text" }
const _hoisted_63 = {
  class: "description-item",
  style: {"width":"520px"}
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description-label" }, "商品名称", -1))
const _hoisted_65 = { class: "description-content bg-text" }
const _hoisted_66 = {
  class: "description-item",
  style: {"width":"100%"}
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description-label" }, "活动标签", -1))
const _hoisted_68 = { class: "description-content" }
const _hoisted_69 = { class: "promotion-label-container" }
const _hoisted_70 = {
  key: 0,
  class: "pre-promotion-label"
}
const _hoisted_71 = {
  key: 0,
  class: "promotion-label"
}
const _hoisted_72 = { style: {"padding":"0 10px"} }
const _hoisted_73 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","margin-bottom":"10px"} }
const _hoisted_74 = { class: "split-total-item-num" }
const _hoisted_75 = { class: "num" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "num",
  style: {"margin-left":"2px"}
}, "PCS", -1))
const _hoisted_77 = { style: {"height":"500px","flex":"auto"} }
const _hoisted_78 = { id: "TOID-SPLIT-PROMOTION-CELL" }
const _hoisted_79 = { class: "promotion-card-scroll-container" }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_82 = { class: "rule-name" }
const _hoisted_83 = {
  key: 0,
  class: "pre-promotion-label"
}
const _hoisted_84 = {
  key: 1,
  class: "promotion-label"
}
const _hoisted_85 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_86 = {
  key: 0,
  class: "plan-name"
}
const _hoisted_87 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_88 = { class: "pkg-col-box" }
const _hoisted_89 = { class: "pkg-text" }
const _hoisted_90 = { class: "pkg-text num" }
const _hoisted_91 = { class: "pkg-unit" }


const __default__ = {
  name: 'TradeOrderItemDetail'
};

import {computed, createVNode, nextTick, onUnmounted, reactive, ref, watch, type Ref} from 'vue';
import {VxeButtonEvents} from 'vxe-table';
import {
  OioButton,
  OioInput,
  OioMessage,
  OioModal,
  OioSpin,
  OioDateTimePicker,
  OioTag,
  OioPagination,
  OioForm,
  OioFormItem, OioRow, OioCol
} from '@kunlun/vue-ui-antd';
import {
  ExclamationCircleOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  TagFilled,
  LeftOutlined,
  RightOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined
} from '@ant-design/icons-vue';
import XLSX from 'xlsx';
import {Modal} from 'ant-design-vue';
import {cloneDeep, debounce} from 'lodash-es';
import {getImportTemplateUrl, queryWorkbook} from '../../../../api/excel';
import {iterateObjDeep} from '../../../../utils/object';
import {removeDecimalZero} from '../../../../utils/number';
import {vxeTableRemoveZeroFormatter} from '../../../../utils/fotmatter';
import {useFullscreen} from '../../../../hooks/fullscreen';
import {searchItemsByCondition} from './services';
import StoreDialog from './StoreTableDialog.vue';
import {priceTypeEnumMap, inventoryStatusMap} from '../../../../constants';
import {SelectOption} from '../../../../types';
import {queryFreeReasonList, querySimpleCodeList} from '../../../../api';
import {Message} from '../../../../constants/message';

interface baseDataType {
  disabled: boolean;
  editBizTypeArr: string[];
  editOrderTypeArr: string[];
  promotionTypeEnumList: null | { name: string; value: string }[];
}

interface IProps {
  quicklyAdd: any;
  state: any;
  setState: any;
  exportFile: any;
  formData: any;
  change: any;
  assignToFormData: any;
  orderPreview: (dataSource: any[]) => any;
  resetData: any;
  mountedProcessFlag: any;
  isPromotionOrder: any;
  rModel: any;
  setTableEditStatus: (status: 'OPEN' | 'CLOSED') => void;
  disabledImport: boolean;
  disabledAddOrDelRow: boolean;
  disabledFastAddRow: boolean;
  baseData: baseDataType
}

interface SpecificationData {
  count: any;
  conversionRules: string;
  id: string;
  pcsCount: number;
  unitCode: string;
  unitName: string;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    quicklyAdd: null,
    state: null,
    setState: null,
    exportFile: null,
    formData: null,
    change: null,
    assignToFormData: null,
    orderPreview: null,
    resetData: null,
    mountedProcessFlag: null,
    isPromotionOrder: null,
    rModel: null,
    setTableEditStatus: null,
    disabledImport: { type: Boolean },
    disabledAddOrDelRow: { type: Boolean },
    disabledFastAddRow: { type: Boolean },
    baseData: null
  },
  setup(__props: any, { emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props as { quicklyAdd: any, state: any, setState: any, exportFile: any, formData: any, change: any, assignToFormData: any, orderPreview: (dataSource: any[]) => any, resetData: any, mountedProcessFlag: any, isPromotionOrder: any, rModel: any, setTableEditStatus: (status: 'OPEN' | 'CLOSED') => void, disabledImport: boolean, disabledAddOrDelRow: boolean, disabledFastAddRow: boolean, baseData: baseDataType }

const VNodes = (_, {attrs}) => {
  return attrs.vnodes;
};




let count = 1;
const storeDialogVisible = ref(false);
const storeRow = ref<any>();

const tableRef = ref<any>();
const errorTableRef = ref<any>();
const errorData = ref<any[]>([]);
const selectRecords = ref<any[]>([]);
const isAllChecked = ref(false);
const isIndeterminate = ref(false);
const searchVal = ref('');
const searchStr = ref('');
const errorModal = ref<boolean>(false);
const tips = ref('');
const addLoading = ref(false);
const tableLoading = ref(false);
const downloadLoading = ref(false);
const importLoading = ref(false);
const exportLoading = ref(false);
const dataSource = ref<any[]>([]);
const displayTableData = ref<any[]>([]);
const freeReasonOptions = ref<SelectOption[]>([]);
const disableDelete = ref(false);
const displayTablePagination = reactive({
  current: 1,
  pageSize: 15,
  total: 0
});

const cartSourceMap = {
  MERCHANT: '交易台',
  APP_CREATE_ORDER: 'APP',
  STORE: '商城',
  LIVE_CREATE: '直播',
  ORDER_MEETING: '订货会',
  BRAND_STORE_PLATFORM: '品牌分销工作台'
};

const discountForm = ref<any>({
  platformDiscount: 0,
  provinceDiscount: 0,
  productDiscount: 0
})

// 前端计算的商品总数的各行总和
const _itemNumTotal = computed(() =>
    dataSource.value.reduce((acc, cur) => {
      const itemNum = Number(cur?.itemNum ?? 0);
      return acc + (Number.isNaN(itemNum) ? 0 : itemNum);
    }, 0)
);
// const editRowBackup = ref<any>({});

const contentRef = ref<HTMLElement | undefined>();
const {isFullscreen, toggleFullscreen} = useFullscreen(contentRef);

const getPopupContainer = (triggerNode: HTMLElement) => {
  let curNode = triggerNode;
  while (curNode) {
    if (curNode.id === 'TOID-content' || curNode.id === 'TOID-PROMOTION-CELL') {
      return curNode;
    }
    curNode = curNode.parentNode as HTMLElement;
  }
  return document.body;
};
const getModalContainer = () => {
  const container = document.getElementById('TOID-content');
  return container ?? document.body;
};

const checkboxChangeEvent = () => {
  const $table = tableRef.value;
  if ($table) {
    isAllChecked.value = $table.isAllCheckboxChecked();
    isIndeterminate.value = $table.isAllCheckboxIndeterminate();
    selectRecords.value = $table.getCheckboxRecords();
  }
};

const calcIsGift = (row) => {
  return props.isPromotionOrder && row?.isGifted;
};
// 查看库存
const viewStorage = ({row}) => {
  storeRow.value = row;
  storeDialogVisible.value = true;
};

const beforeEditMethod = (scope) => {
  const isEmpty = !scope.row?.outCode;
  const isGift = calcIsGift(scope.row);
  const title = scope.column.title;
  const include = ['记账时间规则', '指定账期天数', '指定记账时间', '结算单价'].includes(title);

  return (!isEmpty && !isGift) || include;
};

const handleSpecChange = (item, e) => {
  item.count = Number(String(e.target.value).replace(/[^0-9]/g, ''));
};

const exportDataEvent: VxeButtonEvents.Click = () => {
  try {
    exportLoading.value = true;
    props.exportFile(dataSource.value);
  } finally {
    exportLoading.value = false;
  }
};

const handleDownload = async () => {
  try {
    downloadLoading.value = true;
    const res = await queryWorkbook({
      ...props.rModel,
      model: 'deli.aries.seller.SellerDistributorCreateOrderSaleSku'
    });
    let id: any = '';
    if (isMarketOrder.value) {
      //商超订单模板
      id = res.content?.filter(item => item.displayName === '代客下单商品改价小导入模板')?.[0]?.id
    } else if (props.formData?.bizType === 'CUSTOM_PRODUCT') {
      // 代客下单定制商品
      id = res.content?.filter(item => item.displayName === '代客下单定制产品导入模板')?.[0]?.id
    } else if(props.formData?.orderType === 'REGULAR') {
      // 代客下单定制商品
      id = res.content?.filter(item => item.displayName === '代客下单常规订单导入模板')?.[0]?.id
    }else if(props.formData?.orderType==='CUSTOM_MADE') {
      // 代客下单定制脱单 高级定制
      id = res.content?.filter(item => item.displayName === '代客下单定制脱单商品小导入模板')?.[0]?.id
    }else {
      //其他订单模板
      id = res.content?.filter(item => item.displayName === '代客下单商品小导入模板')?.[0]?.id
    }
    const res1 = await getImportTemplateUrl(props.rModel, id);
    window.open(res1.redirectUri);
  } finally {
    downloadLoading.value = false;
  }
};

const importDataEvent = () => {
  // 弹出选择文件弹窗
  const input = document.createElement('input');
  input.type = 'file';
  input.style.display = 'none';

  // sheet_to_array的实现
  function parseExcelSheetToArrays(sheet) {
    const Range = {
      x1: sheet['!ref'].split(':')[0].match(/^[A-Z]+/)[0],
      y1: sheet['!ref'].split(':')[0].match(/\d+$/)[0],
      x2: sheet['!ref'].split(':')[1].match(/^[A-Z]+/)[0],
      y2: sheet['!ref'].split(':')[1].match(/\d+$/)[0]
    };

    const tableDataArr: any = [];
    for (let y = Range.y1; y <= Range.y2; y++) {
      // 行遍历
      const rowArr: any[] = [];
      for (let x = Range.x1.charCodeAt(); x <= Range.x2.charCodeAt(); x++) {
        // 列遍历 TD:暂时只支持到A~Z列，有需要的自己优化
        const position = String.fromCharCode(x) + y;
        // @ts-ignore
        rowArr.push(sheet?.[position]?.v ?? null);
      }
      tableDataArr.push(rowArr);
    }

    // 移除表头
    tableDataArr.shift();

    // 过滤空行
    return tableDataArr.filter((row) => row.some((cell) => cell !== null));
  }

  const handleChangeFile = (e) => {
    const file = <File>e.target.files[0];
    const format = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
    const importFileFormat = ['xlsx', 'xls'];
    if (!importFileFormat.includes(format)) {
      OioMessage.error('仅支持上传excel文件');
    } else {
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        try {
          const data = e.target.result;
          const workbook = XLSX.read(data, {type: 'binary', cellDates: true});
          const sheetNames = workbook.SheetNames;
          const worksheet = workbook.Sheets[sheetNames[0]];
          const arr = parseExcelSheetToArrays(worksheet);
          let str = '';
          arr.forEach((row, rowIndex) => {
            str += `${rowIndex}\t`;

            row.forEach((col, colIndex) => {
              if (colIndex !== row.length - 1) {
                str += `${col}\t`;
              } else {
                str += `${col} `;
              }
            });
          });

          importLoading.value = true;
          tableLoading.value = true;
          await queryData(str, true);
        } finally {
          importLoading.value = false;
          tableLoading.value = false;
        }
      };
      reader.readAsBinaryString(file);
    }
    // 需要清除input的value，不然相同的文件无法上传多次
    if (input.value) {
      input.value = '';
    }
  };

  input.onchange = handleChangeFile;
  input.click();
};

const insertEvent = async (row: any) => {
  const $table = tableRef.value;
  if ($table) {
    const record = {};
    const {row: newRow} = await $table.insertAt(record, row);
    newRow.isExamine = true;
    dataSource.value.push(newRow);
  }
};

// 重新获取页面数据
const orderPreview = async () => {
  try {
    const res = await props.orderPreview(dataSource.value);
    if (res?.createOrderSaleSkuList) {
      const emptyRows = dataSource.value.filter((item) => !item.outCode);
      dataSource.value = [...res.createOrderSaleSkuList, ...emptyRows];
      tableRef.value?.clearCheckboxRow?.();
      checkboxChangeEvent();
    }
    disableDelete.value = typeof res.allowDelete === 'boolean' && !res.allowDelete;
  } catch (error) {
    if (props.formData.bizType === 'OFFLINE_DROPSHIPPING' && unProxySendGood?.outCode) {
      const isEmpty = !unProxySendGood?.outCode;
      const realIndex = dataSource.value.findIndex((item) => item.outCode === unProxySendGood?.outCode);
      dataSource.value.splice(realIndex, 1);
      tableRef.value.reloadData(dataSource.value);
      !isEmpty && (await orderPreview());
    }
  }
};

const removeRow = ({row, rowIndex}) => {
  Modal.confirm({
    title: '确认删除吗?',
    icon: createVNode(ExclamationCircleOutlined),
    getContainer: () => document.querySelector('#TOID-content') || document.body,
    async onOk() {
      tableLoading.value = true;
      try {
        const isEmpty = !row?.outCode;
        const realIndex = dataSource.value.findIndex((item) => item.outCode === row?.outCode);
        dataSource.value.splice(realIndex, 1);
        tableRef.value.reloadData(dataSource.value);
        !isEmpty && (await orderPreview());
      } finally {
        tableLoading.value = false;
      }
    }
  });
};

const queryData = async (str, isImport = false) => {
  searchVal.value = '';
  try {
    addLoading.value = true;
    tableLoading.value = true;

    let condition = str;

    // 快速添加
    if (!isImport && str) {
      condition = condition
          .split(' ')
          .map((v, index) => {
            const rowIndex = displayTableData.value.length + index + 1;
            return rowIndex + '\t' + v;
          })
          .join(' ');
    }
    const res = (await props.quicklyAdd(condition)) ?? {};
    res.createOrderSaleSkuList?.forEach((i) => (i.isExamine = true));

    if (isImport) {
      res.createOrderSaleSkuList?.sort((a, b) => (a.rowIndex || 0) - (b.rowIndex || 0));
    } else {
      res.createOrderSaleSkuList?.reverse();
    }
    assignRowsIntoSourceData(res.createOrderSaleSkuList ?? []);
    if (res.errMessages?.length) {
      tips.value = res.errMessages[0];
      errorData.value = res.errMessages.map((msg) => ({msg}));
      errorTableRef.value?.reloadData(errorData.value);
    }

    await orderPreview();
  } finally {
    addLoading.value = false;
    tableLoading.value = false;
  }
};

let cacheChangeTimeoutId: number | null = null;
const CACHE_CHANGE_TIMEOUT = 100;
const onEditClosed = (scope) => {
  // // 防止数组顺序不同导致判断为不相同
  // const now = cloneDeep(scope.row);
  // const before = cloneDeep(editRowBackup.value);
  // now?.deliAriesItemSpecificationsProxyList?.sort((a, b) => (a?.id > b?.id ? 1 : -1));
  // before?.deliAriesItemSpecificationsProxyList?.sort((a, b) => (a?.id > b?.id ? 1 : -1));
  //
  // before?.deliAriesItemSpecificationsProxyList?.forEach((item) => {
  //   if (!item.count) {
  //     item.count = 0;
  //   }
  // });
  // const changed = !isEqual(now, before);
  // nextTick(() => {
  //   changed && ['包装单位'].includes(scope.column.title) && onChangeRow(scope)
  // });
  // editRowBackup.value = cloneDeep(scope.row);
  cacheChangeTimeoutId !== null && clearTimeout(cacheChangeTimeoutId);
  cacheChangeTimeoutId = setTimeout(() => {
    onChangeRow(scope);
  }, CACHE_CHANGE_TIMEOUT) as unknown as number;
};

const onEditActived = (scope) => {
  cacheChangeTimeoutId !== null && clearTimeout(cacheChangeTimeoutId);
  // editRowBackup.value = cloneDeep(scope.row);
  props.setTableEditStatus('OPEN');
};

const onChangeRow = async ({row, rowIndex, columnIndex, column}, isAdd = false) => {
  const copy = cloneDeep(dataSource.value);
  const sameRow = copy.find((r, i) => {
    return i !== rowIndex && isRowConflict(r, row);
  });
  // const isEmpty = !row?.outCode;
  if (sameRow && isAdd) {
    OioMessage.info('该商品已存在');
    throw new Error();
  }
  try {
    addLoading.value = true;
    tableLoading.value = true;
    dataSource.value.forEach((item, index) => {
      onSpecChange(item.uuid);
    });
    // const res = await props.updateOne(row);
    // if (res.errMessages?.length) {
    //   tips.value = res.errMessages[0];
    //   errorData.value.unshift(...res.errMessages.map((msg) => ({ msg })));
    //   errorTableRef.value?.reloadData(errorData.value);
    //   throw new Error(tips.value);
    // } else {
    //   dataSource.value[rowIndex] = res.createOrderSaleSkuList[0] ?? {};
    //   tableRef.value.reloadData(dataSource.value);
    // }
    tableRef.value?.clearEdit();
    await orderPreview();
    await nextTick();
  } finally {
    addLoading.value = false;
    tableLoading.value = false;
    props.setTableEditStatus('CLOSED');
  }
};

// 省切换时更新数据
watch(
    () => props.formData?.offlineDeliveryAddress,
    async (newVal, oldVal) => {
      if (
          newVal?.provinceCode != oldVal?.provinceCode &&
          props.formData.ariesIssuingMethodEnum === 'ONE' &&
          props.formData.createOrderSaleSkuList?.length > 0
      ) {
        try {
          addLoading.value = true;
          tableLoading.value = true;
          await orderPreview();
        } finally {
          addLoading.value = false;
          tableLoading.value = false;
        }
      }
    },
    {deep: true}
);
// 省切换时更新数据
watch(
    () => props.formData?.orderType,
    async (newVal, oldVal) => {
      if (newVal && oldVal) {
        selectRecords.value = dataSource.value;
        await batchDelete(selectRecords.value.filter((row) => !calcIsGift(row)));
        selectRecords.value = [];
      }
    }
);
const isMarketOrder = ref<boolean>(false);
// 监听商超订单
watch(
  () => props.formData?.bizType,
  (newVal, oldVal) => {
    if (props.formData?.bizType === 'CHANGE_ORDER' || props.formData?.bizType === 'SUPERMARKET' ) {
      isMarketOrder.value = true;
    } else {
      isMarketOrder.value = false;
    }
  }
);

const onActivityChange = async (promotionId, scope, isAdd = true) => {
  const selected = promotionId === scope.row.sortByGroup;
  if (isAdd && selected) {
    return;
  }
  const {itemId} = scope.row;
  const copy = cloneDeep(props.formData.cartItemForPromotions) ?? [];
  const target = copy.find((item) => item.itemId === itemId);
  if (target) {
    target.promotionIds = [promotionId];
  } else {
    copy.push({
      promotionIds: [promotionId],
      itemId
    });
  }
  props.formData.cartItemForPromotions = copy;
  await onChangeRow(scope);
};

const showErrorModal = () => {
  errorModal.value = true;
};

const onSortChange = async (value) => {
  // eslint-disable-next-line vue/no-mutating-props
  props.state.cartGroupType = value;
  tableLoading.value = true;
  try {
    await orderPreview();
  } finally {
    tableLoading.value = false;
  }
  // const copyData = cloneDeep(dataSource);
  // if (value === 'order_desc') {
  // } else {
  // }
  // props.reloadDataSource(copyData);
};

watch(
    dataSource,
    (value) => {
      if (props.mountedProcessFlag) {
        props.change(value);
      }
    },
    {deep: true}
);

const stop1 = watch(
    () => props.formData.createOrderSaleSkuList,
    (value) => {
      if (value?.length) {
        stop1();
      }
      dataSource.value = value ?? [];
    },
    {deep: true}
);

watch(
    () => props.formData.sellerPartnerRelationApplySearch?.id,
    (val, oldVal) => {
      if (props.mountedProcessFlag && val !== oldVal) {
        dataSource.value = [];
        props.resetData();
      }
    }
);

function useSpecifications(_dataSource: Ref<any[]>) {
  const specificationDataListList = ref<Record<number, SpecificationData[]>>({});

  const updateDataListList = () => {
    _dataSource.value.forEach((i) => {
      specificationDataListList.value[i.uuid] = generateSpecListByRowData(i);
    });
  };

  const generateSpecListByRowData = (row) => {
    if (!row?.deliAriesItemSpecificationsProxyList) {
      return [];
    }
    const options = row.deliAriesItemSpecificationsProxyList;
    let {itemNum} = row;
    const copy = cloneDeep(options);
    // 顺序大到小，方便计算，后续通过reverse改为小到大，方便展示
    copy.sort((a, b) => b.pcsCount - a.pcsCount || (b.unitName > a.unitName ? 1 : -1));
    // copy
    //     .filter((item) => item.isEnabled !== false)
    //     .map((spe) => {
    //       const count = Math.floor(itemNum / spe.pcsCount);
    //       itemNum -= count * spe.pcsCount;
    //       spe.count = count;
    //       return spe;
    //     })
    //     .reverse() ?? []
    return (
        copy
            .map((spe) => {
              const count = Math.floor(itemNum / spe.pcsCount);
              itemNum -= count * spe.pcsCount;
              spe.count = count;
              return spe;
            })
            .reverse() ?? []
    );
  };

  watch(
      _dataSource,
      (val) => {
        updateDataListList();
      },
      {deep: true, immediate: true}
  );

  const onSpecChange = (uuid: string) => {
    const targetItemNum = specificationDataListList.value[uuid].reduce((acc, cur) => {
      return acc + cur.pcsCount * cur.count;
    }, 0);
    const row = _dataSource.value.find((item) => item.uuid === uuid);
    if (!row?.deliAriesItemSpecificationsProxyList) {
      return;
    }
    // if (!item.outCode) {
    //   item.itemNum = null;
    //   return;
    // }
    const targetSpec = generateSpecListByRowData({
      ...row,
      itemNum: targetItemNum
    });
    row.deliAriesItemSpecificationsProxyList = targetSpec;
    row.itemNum = targetItemNum;
  };

  return {
    specificationDataListList,
    onSpecChange
  };
}

const {specificationDataListList, onSpecChange} = useSpecifications(dataSource);

// 行唯一性比较
const isRowConflict = (row1, row2) => {
  if (props.formData?.orderType === 'CUSTOM_MADE'){
    //定制订单不校验
    return false;
  }
  const sameId = row1.itemId !== undefined && row1.itemId === row2.itemId;
  const sameGifted = (row1.isGifted ?? false) === (row2.isGifted ?? false);
  const samePromotion = (row1.promotionId ?? '0') === (row2.promotionId ?? '0');
  // row1.calcPromotionIds?.length &&
  // row1.calcPromotionIds?.length === row2.calcPromotionIds?.length &&
  // isEqual([...row1.calcPromotionIds]?.sort(), [...row2.calcPromotionIds]?.sort());
  return sameId && sameGifted && (!props.isPromotionOrder || samePromotion);
};

// 定制订单 行唯一性比较
const isCustomRowConflict = (row1, row2) => {
  const sameId = row1.itemId !== undefined && row1.itemId === row2.itemId;
  const sameColor = row1.itemColor === row2.itemColor;
  const sameGifted = (row1.isGifted ?? false) === (row2.isGifted ?? false);
  const samePromotion = (row1.promotionId ?? '0') === (row2.promotionId ?? '0');
  return sameId && sameColor && sameGifted && (!props.isPromotionOrder || samePromotion);
};

const assignRowsIntoSourceData = (rows: any[]) => {
  dataSource.value = mergeSameRows(dataSource.value.concat(rows));
  tableRef.value.reloadData(dataSource.value);
};

const mergeSameRows = (rows: any[]) => {
  let flag = false;
  const result: any[] = [];
  rows.forEach((row) => {
    let repeatedRow;
    const targetRow = result.find((_row) => {
      const isRepeat = isRowConflict(_row, row);
      if (isRepeat) {
        repeatedRow = row;
      }
      return isRepeat;
    });
    if (targetRow) {
      targetRow.itemNum += repeatedRow.itemNum;
      //常规订单促销简码也要覆盖
      if (props.formData?.orderType === 'REGULAR') {
        targetRow.promotionSimpleCode=repeatedRow.promotionSimpleCode;
        targetRow.promotionSimpleCodeObjId = simpleCodeOptions.value.find(option =>
            option.label.includes(targetRow.promotionSimpleCode)
        )?.id;
      }
      flag = true;
    } else {
      result.push(row);
    }
  });
  if (flag) {
    OioMessage.info('添加时存在重复商品，商品数量已相加合并');
  }
  return result;
};

const allItem = ref<any[]>([]);
const itemOptions = ref<any[]>([]);
const query = ref('');
const currentPage = ref(1);
const pageSize = 10;
const searchLoading = ref(false);
const timer = ref<any>(null);
const onItemSearch = async (q: string, coverData = true) => {

  searchLoading.value = true;
  try {
    query.value = q;
    if (!props.formData.buyerPartnerId || !props.formData.salesOffice) {
      OioMessage.error('请将买卖家信息填写完整!');
      return;
    }
    if (!props.formData.distributionChannel?.id) {
      OioMessage.error('缺少分销渠道数据!');
      return;
    }
    if (!query.value) {
      clearItemOptions();
      return;
    }
    if (!props.rModel) {
      return;
    }
    const data: Record<any, any> = cloneDeep({
      buyerPartnerId: props.formData.buyerPartnerId,
      salesOffice: props.formData.salesOffice,
      createOrderSaleSkuList: [{searchKey: query.value}],
      bizType: props.formData.bizType,
      distributionChannelId: props.formData.distributionChannel.id,
      sellerPartnerRelationApplySearch: props.formData.sellerPartnerRelationApplySearch
    });
    // 集中收单
    if ((props.formData.orderType === 'CENTRALIZED_ACQUIRING' || props.formData.bizType === 'POLICY_PROMOTION') && !!props.formData.deliAriesPromotionPlan) {
      data.deliAriesPromotionPlan = props.formData.deliAriesPromotionPlan;
      delete data.deliAriesPromotionPlan.META_BIT;
      delete data.deliAriesPromotionPlan._d_model;
    }

    iterateObjDeep(data, (obj: Record<any, any>) => {
      delete obj.__draftId;
      delete obj._X_ROW_KEY;
    });
    const pagination: Record<any, any> = cloneDeep({
      currentPage: currentPage.value,
      size: pageSize
    });
    const _allItem = (await searchItemsByCondition(props.rModel, {data, pagination})) ?? [];
    const _itemOptions =
        _allItem.map((item) => ({
          label: item.name,
          value: item.outCode
        })) ?? [];

    if (_allItem.length === 0) {
      currentPage.value = Math.max(1, currentPage.value - 1);
      nextPageLock.value = true;
    } else {
      nextPageLock.value = _allItem.length < pageSize;
    }

    if (coverData) {
      allItem.value = _allItem;
      itemOptions.value = _itemOptions;
    } else {
      allItem.value.push(..._allItem);
      itemOptions.value.push(..._itemOptions);
    }
  } finally {
    searchLoading.value = false;
  }
};

const onItemSearchDebounce = debounce(onItemSearch, 200);

const clearItemOptions = () => {
  itemOptions.value = [];
  query.value = '';
  currentPage.value = 1;
};
let unProxySendGood: any = {}; //记录不是一件代发的商品
const onSelectItemChange = async (outCode, scope) => {
  const itemData = allItem.value.find((item) => item.outCode === outCode);
  dataSource.value[scope.rowIndex] = {...cloneDeep(itemData), itemNum: 0, promotionId: '0', isExamine: true};
  tableRef.value.reloadData(dataSource.value);
  unProxySendGood = scope.row;
  Object.assign(scope.row, {...cloneDeep(itemData), itemNum: 0, promotionId: '0', isExamine: true});
  try {
    await onChangeRow(scope, true);
  } catch (e) {
    dataSource.value[scope.rowIndex] = {};
    tableRef.value.reloadData(dataSource.value);
    clearItemOptions();
    throw e;
  }
};

const prePageEnabled = computed(() => currentPage.value > 1);
const nextPageLock = ref(false);
const nextPageEnabled = computed(() => !nextPageLock.value);
// const nextPageEnabled = computed(() => currentPage.value < Math.ceil(totalNum.value / pageSize));

const onCurPageChange = (diff: number) => {
  if (diff < 0 && !prePageEnabled.value) return;
  if (diff > 0 && !nextPageEnabled.value) return;
  currentPage.value = Math.max(1, Math.round(currentPage.value + diff));
  onItemSearch(query.value, true);
};

const onTimeRuleChange = (val, row) => {
  if (val === 'DELIVERY_TIME') {
    row.accountDate = null;
  } else {
    row.paymentDays = null;
  }
};

const onSimpleCodeChange = async (value,row) => {
  
  // props.setTableEditStatus('OPEM')
  console.log('onSimpleCodeChange', value, row);
  row.promotionSimpleCodeObjId = value;
  const obj =  simpleCodeList.value.content.find(n=>n.id == value);
  console.log(obj);
  row.promotionSimpleCodeObj = obj;
  row.promotionSimpleCode = obj.simpleCode;
  // props.setTableEditStatus('CLOSED')
  await orderPreview();
};

const openGift = () => {
  props.setState({
    showGiftDrawer: true
  });
};
const _selectGifts = ref([]);

// 相同promotionId的项合并，并保留对selectedGift的引用 用于修改数量
const mergedDataListMap = computed(() => {
  const map = new Map();
  _selectGifts.value?.forEach((item: Record<any, any>) => {
    let arr = map.get(item.promotionId);
    if (!arr) {
      arr = [];
    }
    arr.push(item);
    map.set(item.promotionId, arr);
  });
  return map;
});
const selectedActive = computed(() => mergedDataListMap.value.get(props.state.selectedActivePromotionId) ?? []);
const calcRemainItemNum = (item: any) => {
  return item?.selectGifts?.reduce((remain, acc) => {
    return Math.max(remain - acc.itemNum, 0);
  }, item?.limitSelectNum ?? 0);
};

// 赠品列表数据变更时默认选中第一个
watch(
    () => props.formData?.selectGifts,
    (val) => {
      if (val?.length > 0) {
        props.setState({
          selectedActivePromotionId: val[0].promotionId
        });
      }
    },
    {
      immediate: true
    }
);

const onGiftDrawerOpen = () => {
  _selectGifts.value = cloneDeep(props.formData?.selectGifts);
};

watch(
    () => props.state.showGiftDrawer,
    (val) => {
      if (val) {
        onGiftDrawerOpen();
      }
    }
);

const confirmBtnLoading = ref(false);
const onGiftDrawerConfirm = async () => {
  tableLoading.value = true;
  confirmBtnLoading.value = true;
  try {
    props.formData.selectGifts = _selectGifts.value;
    await orderPreview();
    props.setState({
      showGiftDrawer: false
    });
  } finally {
    tableLoading.value = false;
    confirmBtnLoading.value = false;
  }
};

const handleBatchDeleteBtnClick = () => {
  Modal.confirm({
    title: '确认删除选中的商品吗？',
    icon: createVNode(ExclamationCircleOutlined),
    getContainer: () => document.querySelector('#TOID-content') || document.body,
    async onOk() {
      await batchDelete(selectRecords.value.filter((row) => !calcIsGift(row)));
      selectRecords.value = [];
    }
  });
};

const batchDelete = async (rowList: Record<any, any>[]) => {
  tableLoading.value = true;
  try {
    const allEmpty = rowList.every((item) => !item.outCode);
    dataSource.value = dataSource.value.filter((item) => {
      return !rowList.find((row) => row.outCode === item.outCode);
    });
    tableRef.value.reloadData(dataSource.value);
    !allEmpty && (await orderPreview());
  } finally {
    tableLoading.value = false;
  }
};

const batchEditModalVisible = ref(false);
const batchDiscountModalVisible = ref(false);
const originalEditTypeOptions = ref();
// 定制订单
const isCustomOrder = ref(false);
const commonBatchEditOptions = [
  {label: '记账时间规则', value: 'accountTimeRule'},
  {label: '指定账期天数', value: 'paymentDays'},
  {label: '指定记账时间', value: 'accountDate'},
  {label: '免费原因', value: 'freeReasonStr'}
];
watch(
  () => props.formData?.orderType,
  (val) => {
    if (val === 'CUSTOM_MADE') {
      originalEditTypeOptions.value = commonBatchEditOptions;
    }else if(val === 'REGULAR') {
      originalEditTypeOptions.value = [
        { label: '是否免费', value: 'isGifted' },
        { label: '是否考核', value: 'isExamine' },
        { label: '促销简码', value: 'promotionSimpleCode' },
        ...commonBatchEditOptions
      ];
    } else {
      originalEditTypeOptions.value = [
        { label: '是否免费', value: 'isGifted' },
        { label: '是否考核', value: 'isExamine' },
        ...commonBatchEditOptions
      ];
    }
    isCustomOrder.value = val === 'CUSTOM_MADE';
  },
  {
    immediate: true
  }
);
const displayEditTypeOptions = computed(() => {
  type Writeable<T> = { -readonly [P in keyof T]: T[P] };
  const copy: any[] = cloneDeep(originalEditTypeOptions.value);
  copy.forEach((item) => {
    if (editModalDataList.value.some((data) => data.type === item.value)) {
      item.disabled = true;
    } else {
      item.disabled = false;
    }
  });
  return copy;
});
const getOriginEditModalDataList = () => {
  // const result: {
  //   type?: typeof originalEditTypeOptions[number]['value'];
  //   value?: any;
  //   id: number;
  // }[] = [
  //   { id: 0, type: 'isGifted', value: true },
  //   { id: 1, type: 'isExamine', value: false }
  // ];
  // if (props.isPromotionOrder) {
  //   delete result[0].value;
  // }
  // return result;
  return [{id: 0}] as { type?: typeof originalEditTypeOptions.value[number]['value']; value?: any; id: number }[];
};
const editModalDataList = ref(getOriginEditModalDataList());
const handleBatchEditBtnClick = () => {
  batchEditModalVisible.value = true;
  editModalDataList.value = getOriginEditModalDataList();
};

const handleBatchEditDiscountClick = () => {
  const hasExamineTrue = selectRecords.value.some(record => record.isExamine === true);
  const hasExamineFalse = selectRecords.value.some(record => record.isExamine === false);

  if (hasExamineTrue && hasExamineFalse) {
    OioMessage.error('请选择相同考核标签明细');
    return;
  }
  discountForm.value = {
    platformDiscount: 0,
    provinceDiscount: 0,
    productDiscount: 0
  }
  batchDiscountModalVisible.value = true;
}

const onSubmitBatchEdit = async () => {
  batchEditModalVisible.value = false;
  tableLoading.value = true;
  try {
    await applyBatchEdit();
  } finally {
    tableLoading.value = false;
  }
};

const onSubmitBatchEditDiscount = async () => {

  if((+discountForm.value.platformDiscount) + (+discountForm.value.provinceDiscount) + (+discountForm.value.productDiscount) != 100) {
    OioMessage.error('让利总和必须为100');
    return;
  }
  batchDiscountModalVisible.value = false;
  tableLoading.value = true;
  try {
    await applyBatchEditDiscount();
  } finally {
    tableLoading.value = false;
  }
};

const applyBatchEdit = async () => {
  if (editModalDataList.value.every((item) => item.value === undefined)) {
    return;
  }

  selectRecords.value?.forEach((item) => {
    item.outCode &&
    editModalDataList.value.forEach(({type, value}) => {
      console.log(type);
      if (type && value !== undefined) {
        item[type] = value;
        // 记账时间规则
        if (['accountTimeRule', 'paymentDays', 'accountDate'].includes(type)) {
          // 指定天数时，时间置空
          if (item.accountTimeRule === 'DELIVERY_TIME') {
            item.accountDate = null;
          }
          // 指定时间时，天数置空
          else {
            item.paymentDays = null;
          }
        }
        // 仅免费行能编辑免费原因
        else if (type === 'freeReasonStr' && !item.isGifted) {
          item.freeReason = null;
        } else if (type === 'promotionSimpleCode') {
          console.log(value);
          const obj =  simpleCodeList.value.content.find(n => n.id == value);
          item.promotionSimpleCodeObjId = value;
          item.promotionSimpleCodeObj = obj
          item.promotionSimpleCode = obj.simpleCode;
        }
      }
    });
  });
  tableLoading.value = true;
  try {
    await orderPreview();
  } finally {
    tableLoading.value = false;
  }
};

const validatePlatformDiscount = (rule: any, value: any, callback: any) => {
  
  console.log(value);
  if(discountForm.value.provinceDiscount == undefined || discountForm.value.productDiscount == undefined)
  {
    return  Promise.resolve();
  }
  if((+value) + (+discountForm.value.provinceDiscount) + (+discountForm.value.productDiscount) != 100)
    return  Promise.reject('让利总和必须为100');
  else
    return  Promise.resolve();
};

const validateProvinceDiscount = (rule: any, value: any, callback: any) => {
  
  console.log(value);
  if(discountForm.value.platformDiscount == undefined || discountForm.value.productDiscount == undefined)
  {
    return  Promise.resolve();
  }
  if((+value) + (+discountForm.value.platformDiscount) + (+discountForm.value.productDiscount) != 100)
    return  Promise.reject('让利总和必须为100');
  else
    return  Promise.resolve();
};

const validateProductDiscount = async (rule: any, value: any, callback: any) => {
  
  console.log(value);
  if(discountForm.value.provinceDiscount == undefined || discountForm.value.platformDiscount == undefined)
  {
    return  Promise.resolve();
  }
  if((+value) + (+discountForm.value.provinceDiscount) + (+discountForm.value.platformDiscount) != 100)
    return  Promise.reject('让利总和必须为100');
  else
    return  Promise.resolve();
};

const applyBatchEditDiscount = async () => {
  
  console.log(discountForm.value);
  selectRecords.value?.forEach((item) => {
    item.provinceDiscount = +discountForm.value.provinceDiscount;
    item.productDiscount = +discountForm.value.productDiscount;
    item.platformDiscount = +discountForm.value.platformDiscount;
  });
  console.log(selectRecords.value);
  tableLoading.value = false;
};

const promotionDropdownOpenMap = ref<Map<any, boolean>>(new Map());
const promotionDropdownDataList = ref<any[]>([]);
const promotionDropdownSelectedDataList = ref<any[]>([]);
const handlePromotionDropdownVisibleChange = (open, scope) => {
  promotionDropdownOpenMap.value.set(scope.rowid, open);
  if (open) {
    promotionDropdownDataList.value = scope.row.canDesignShopMatchRules;
    promotionDropdownSelectedDataList.value = promotionDropdownDataList.value.filter((item) =>
        scope.row.calcPromotionIds?.includes?.(item.promotionId)
    );
  }
};
const multi = computed(() => promotionDropdownSelectedDataList.value.some((item) => item.canSuperposition));
const promotionDropdownDisabledDataList = computed(() => {
  if (!multi.value) return [];

  const availableDataList = promotionDropdownSelectedDataList.value
      // 可叠加活动的可叠加目标活动取交集
      .reduce((acc, cur) => {
        if (!cur.relationPromotionIds) return acc;
        return acc.filter((item) => cur.relationPromotionIds!.includes(item.promotionId));
      }, promotionDropdownDataList.value)
      // 对未选中的可叠加活动进行判断，若已选中的活动中存在不在它的可叠加列表中的活动，则剔除该可叠加活动
      .filter((item) => {
        if (!item.relationPromotionIds) return true;
        return promotionDropdownSelectedDataList.value.every((item2) =>
            item.relationPromotionIds!.includes(item2.promotionId)
        );
      });

  return promotionDropdownDataList.value.filter(
      (item1) =>
          !availableDataList.some((item2) => item2.promotionId === item1.promotionId) &&
          !promotionDropdownSelectedDataList.value.some((item2) => item2.promotionId === item1.promotionId)
  );
});
const handlePromotionCardClick = (item) => {
  const disabled = promotionDropdownDisabledDataList.value.find((item2) => item2.promotionId === item.promotionId);
  if (disabled) {
    return;
  }
  const selected = promotionDropdownSelectedDataList.value.find((item2) => item2.promotionId === item.promotionId);
  if (selected) {
    promotionDropdownSelectedDataList.value = promotionDropdownSelectedDataList.value.filter(
        (item2) => item2.promotionId !== item.promotionId
    );
  } else {
    if (!multi.value) {
      promotionDropdownSelectedDataList.value = [item];
    } else {
      promotionDropdownSelectedDataList.value.push(item);
    }
  }
};

const handleApplyPromotionBtnClick = async (scope) => {
  if (!promotionDropdownSelectedDataList.value?.length) {
    OioMessage.error('请选择至少一个活动!');
    return;
  }
  const {itemId} = scope.row;
  const copy = cloneDeep(props.formData.cartItemForPromotions) ?? [];
  const promotionIds = promotionDropdownSelectedDataList.value.map((item) => item.promotionId);

  const tempRow = cloneDeep(scope.row);
  tempRow.calcPromotionIds = promotionIds;
  tempRow.promotionId = calcPromotionId(tempRow);

  const applyChange = async () => {
    scope.row.calcPromotionIds = promotionIds;
    scope.row.promotionId = calcPromotionId(scope.row);
    assignRowsIntoSourceData([]);
    // dataSource.value = mergeSameRows(dataSource.value);
    // tableRef.value.reloadData(dataSource.value);

    await nextTick(async () => {
      const target = copy.find((item) => item.itemId === itemId);
      if (target) {
        const sameItemIdRowPromotionIds: any[] = [];
        dataSource.value.forEach((row) => {
          if (row.itemId === scope.row.itemId && !row.isGifted) {
            sameItemIdRowPromotionIds.push(...(row.calcPromotionIds ?? []));
          }
        });
        target.promotionIds = Array.from(new Set(sameItemIdRowPromotionIds));
      } else {
        copy.push({
          promotionIds: promotionIds,
          itemId
        });
      }
      props.formData.cartItemForPromotions = copy;
      await onChangeRow(scope);
    });
  };

  const conflictRow = dataSource.value.find((row, i) => i !== scope.rowIndex && isRowConflict(row, tempRow));
  if (conflictRow) {
    Modal.confirm({
      title: '表格中已存在相同的商品，且选择的活动与此次修改后的活动相同，是否进行合并？',
      icon: createVNode(ExclamationCircleOutlined),
      onOk() {
        applyChange();
      }
    });
  } else {
    await applyChange();
  }
};

const splitModalVisible = ref(false);
const splitModalOpenSource = ref<Record<any, any>>({});
const splitModalDataSource = ref<any[]>([]);
const {specificationDataListList: splitSpecificationDataListList, onSpecChange: onSplitSpecChange} =
    useSpecifications(splitModalDataSource);
const splitTotalItemNum = computed(
    () =>
        splitModalDataSource.value?.reduce?.((acc, cur) => {
          return acc + (cur?.itemNum ?? 0);
        }, 0) ?? 0
);

const openSplitModal = (scope) => {
  splitModalOpenSource.value = scope.row;
  splitModalDataSource.value = cloneDeep(
      dataSource.value?.filter?.((item) => item.itemId && item.itemId === scope.row.itemId && !item.isGifted) ?? []
  );
  splitModalVisible.value = true;
};

const getSplitModalPopupContainer = (triggerNode: HTMLElement) => {
  let curNode = triggerNode;
  while (curNode) {
    if (curNode.id === 'TOID-content' || curNode.id === 'TOID-SPLIT-PROMOTION-CELL') {
      return curNode;
    }
    curNode = curNode.parentNode as HTMLElement;
  }
  return document.body;
};
const splitPromotionDropdownOpenMap = ref<Map<any, boolean>>(new Map());
const splitPromotionDropdownDataList = ref<any[]>([]);
const splitPromotionDropdownOpenSource = ref<Record<any, any>>({});
const splitPromotionDropdownSelectedDataList = ref<any[]>([]);
const splitMulti = ref(false);
const handleSplitPromotionDropdownVisibleChange = (open, scope) => {
  splitPromotionDropdownOpenMap.value.set(scope.rowid, open);
  if (open) {
    splitPromotionDropdownOpenSource.value = scope.row;
    splitPromotionDropdownDataList.value = scope.row.canDesignShopMatchRules;
    splitPromotionDropdownSelectedDataList.value = splitPromotionDropdownDataList.value.filter((item) =>
        scope.row.calcPromotionIds?.includes?.(item.promotionId)
    );
  }
};
const splitPromotionDropdownDisabledDataList = computed(() => {
  // 已选中的活动
  const selectedList = splitPromotionDropdownDataList.value.filter((item1) =>
      splitModalDataSource.value.some(
          (item2) => item2.calcPromotionIds?.includes?.(item1.promotionId)
          // !splitPromotionDropdownOpenSource.value.calcPromotionIds?.includes?.(item1.promotionId)
      )
  );
  const selectedUnPrePromotionItem = selectedList.find((item) => !item.prePromotionItem);
  const canSelectUnPrePromotionItems =
      !selectedUnPrePromotionItem ||
      splitPromotionDropdownOpenSource.value.calcPromotionIds?.includes?.(selectedUnPrePromotionItem.promotionId);

  return splitPromotionDropdownDataList.value.filter(
      (item1) =>
          !(
              // 该括号内部值为true表示可选择当前活动
              (
                  splitPromotionDropdownOpenSource.value.calcPromotionIds?.includes?.(item1.promotionId) ||
                  (!selectedList.some((item2) => item2.promotionId === item1.promotionId) &&
                      (item1.prePromotionItem || canSelectUnPrePromotionItems))
              )
          )
      // !splitPromotionDropdownSelectedDataList.value.some((item2) => item2.promotionId === item1.promotionId) &&
  );
});
const handleSplitPromotionCardClick = (item) => {
  const disabled = splitPromotionDropdownDisabledDataList.value.find((item2) => item2.promotionId === item.promotionId);
  if (disabled) {
    return;
  }
  const selected = splitPromotionDropdownSelectedDataList.value.find((item2) => item2.promotionId === item.promotionId);
  if (selected) {
    return;
  } else {
    if (!splitMulti.value) {
      splitPromotionDropdownSelectedDataList.value = [item];
    } else {
      splitPromotionDropdownSelectedDataList.value.push(item);
    }
  }
};

const calcPromotionId = (row: Record<any, any>) => {
  const selectedPromotionList =
      row.canDesignShopMatchRules?.filter((item) => row.calcPromotionIds?.includes(item.promotionId)) ?? [];
  if (!selectedPromotionList?.length || selectedPromotionList?.some((item) => !item.prePromotionItem)) {
    return '0';
  } else {
    return selectedPromotionList?.find((item) => item.prePromotionItem)?.promotionId ?? '0';
  }
};

const handleSplitApplyPromotionBtnClick = async (scope) => {
  // const { itemId } = scope.row;
  // const copy = cloneDeep(props.formData.cartItemForPromotions) ?? [];
  // const target = copy.find((item) => item.itemId === itemId);
  scope.row.calcPromotionIds = splitPromotionDropdownSelectedDataList.value.map((item) => item.promotionId);
  scope.row.promotionId = calcPromotionId(scope.row);
  splitTableRef.value.reloadData(splitModalDataSource.value);
  splitPromotionDropdownOpenMap.value.set(scope.rowid, false);
  // if (target) {
  //   target.promotionIds = promotionIds;
  // } else {
  //   copy.push({
  //     promotionIds: promotionIds,
  //     itemId
  //   });
  // }
  // props.formData.cartItemForPromotions = copy;
  // await onChangeRow(scope);
};
const splitTableRef = ref();
const splitInsertEvent = async (row: any) => {
  const $table = splitTableRef.value;
  if ($table) {
    let record = cloneDeep(splitModalOpenSource.value);
    delete record._X_ROW_KEY;
    delete record.__draftId;
    delete record.calcPromotionIds;
    delete record.tradeOrderDetailId;
    record.itemNum = 0;
    const {row: newRow} = await $table.insertAt(record, row);
    splitModalDataSource.value.push(newRow);
  }
};
const applySplitModalChange = () => {
  const addList: any[] = [];
  let promotionIds: any[] = [];

  splitModalDataSource.value.forEach((row) => {
    row.promotionId = calcPromotionId(row);
  });

  // 弹窗中删除的行也需要在表格中删除
  dataSource.value = dataSource.value.filter((item) => {
    const sameItemId = item.itemId && item.itemId === splitModalOpenSource.value.itemId;
    if (!sameItemId || item.isGifted) {
      return true;
    }
    const deleted = !splitModalDataSource.value.some((row) => isRowConflict(row, item));
    return !deleted;
  });

  splitModalDataSource.value.forEach((item) => {
    promotionIds.push(...(item.calcPromotionIds ?? []));
    const target = dataSource.value.find((row) => isRowConflict(row, item));
    if (target) {
      target.itemNum = item.itemNum;
    } else {
      addList.push(item);
    }
  });
  addList.length && assignRowsIntoSourceData(addList);

  const copy = cloneDeep(props.formData.cartItemForPromotions) ?? [];
  const itemId = splitModalOpenSource.value.itemId;
  if (!itemId) {
    throw new Error('data error');
  }
  const target = copy.find((item) => item.itemId === itemId);

  promotionIds = Array.from(new Set(promotionIds));
  if (target) {
    target.promotionIds = promotionIds;
  } else {
    copy.push({
      promotionIds: promotionIds,
      itemId
    });
  }
  props.formData.cartItemForPromotions = copy;
};
const handleSplitModalConfirmBtnClick = async () => {
  if (splitModalDataSource.value.some((item) => !item.itemNum)) {
    OioMessage.error('存在下单数量为0的商品!');
    return;
  }
  if (splitModalDataSource.value.some((item) => !item.calcPromotionIds?.length)) {
    OioMessage.error('存在未选择活动的商品!');
    return;
  }
  applySplitModalChange();
  splitModalVisible.value = false;
  tableLoading.value = true;
  try {
    await orderPreview();
  } finally {
    tableLoading.value = false;
  }
};

const removeSplitRow = ({row, rowIndex}) => {
  Modal.confirm({
    title: '确认删除吗?',
    icon: createVNode(ExclamationCircleOutlined),
    getContainer: () => document.querySelector('#TOID-content') || document.body,
    onOk() {
      const realIndex = splitModalDataSource.value.findIndex((item) => item.itemId === row.itemId);
      splitModalDataSource.value.splice(realIndex, 1);
      splitTableRef.value.reloadData(splitModalDataSource.value);
    }
  });
};

const calcCellClassName = ({row, rowIndex, $rowIndex, column, columnIndex, $columnIndex}) => {
  if (['包装单位'].includes(column.title)) {
    return 'toid-no-padding-cell';
  }
};

const addEditModalRow = () => {
  editModalDataList.value.push({
    id: count++
  });
};

const removeEditModalRow = (id: number) => {
  editModalDataList.value = editModalDataList.value.filter((item) => item.id !== id);
};

const paginationDisplayTableData = computed(() =>
    displayTableData.value.slice(
        (displayTablePagination.current - 1) * displayTablePagination.pageSize,
        displayTablePagination.current * displayTablePagination.pageSize
    )
);

const updateDisplayTableData = () => {
  const oriData = dataSource.value;
  // 支持分隔符:
  // " \t\n"
  // ","
  const keyList = searchStr.value
      .replace(/[ \t\n]/g, ',')
      .split(',')
      .filter((s) => s);
  if (keyList.length === 0) {
    displayTableData.value = oriData;
  } else {
    displayTableData.value = oriData.filter((item) => {
      const condition1 = keyList.length
          ? keyList.some((key) =>
              ((item.outCode || '') + (item.itemName || '') + (item.productOutCode || ''))?.includes?.(key)
          )
          : true;
      return condition1;
    });
    checkboxChangeEvent();
  }
};

// 注意有多处监听了dataSource
watch(
    [dataSource, searchStr],
    () => {
      updateDisplayTableData();
    },
    {
      immediate: true
    }
);

const downloadErrorfile = () => {
  const $table = errorTableRef.value;
  if ($table) {
    $table.exportData({
      filename: '代客下单商品明细错误信息',
      sheetName: 'Sheet1',
      type: 'csv'
    });
  }
};

const timeRuleOptions = ref<any[]>([
  {
    label: '按发货时间记账',
    value: 'DELIVERY_TIME'
  },
  {
    label: '按指定时间记账',
    value: 'TARGET_TIME'
  }
]);

const simpleCodeOptions = ref<any[]>([]);

const materialGroupFourOptions = ref<any[]>([
  {
    label: '一口价',
    value: 'PRICE'
  },
  {
    label: '实价',
    value: 'REAL_PRICE'
  },
  {
    label: '出厂价',
    value: 'EX_FACTORY_PRICE'
  }
]);

const simpleCodeList = ref<any>([]);

const initData = async () => {
  const res = await queryFreeReasonList(props.rModel);
  freeReasonOptions.value = res.content.map((i) => ({label: i.freeReason, value: i.freeReason}));
  if (freeReasonOptions.value.length) {
    freeReasonOptions.value.unshift({label: '< 置空 >', value: ''});
  }
  simpleCodeList.value = await querySimpleCodeList(props.rModel, "");
  simpleCodeOptions.value = simpleCodeList.value.content.map((i) => ({label: i.simpleCode + "-" + i.description, value: i.id}));
  console.log(simpleCodeList);
  console.log(simpleCodeOptions);
};

initData();

// 推广方案更改时，清空数据
const handleChangeActivityPlan = (e) => {
  if ([Message.ChangeActivityPlan, Message.ChangeBizType].includes(e.data)) {
    dataSource.value = [];
    props.resetData();
  }
};
window.addEventListener('message', handleChangeActivityPlan);
onUnmounted(() => {
  window.removeEventListener('message', handleChangeActivityPlan);
});

return (_ctx: any,_cache: any) => {
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_vxe_switch = _resolveComponent("vxe-switch")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock("div", {
    class: "content",
    ref_key: "contentRef",
    ref: contentRef,
    id: "TOID-content"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(OioButton), {
            type: "primary",
            onClick: handleDownload,
            loading: downloadLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("下载模版")
            ]),
            _: 1
          }, 8, ["loading"]),
          (!__props.disabledImport)
            ? (_openBlock(), _createBlock(_unref(OioButton), {
                key: 0,
                type: "primary",
                onClick: importDataEvent,
                loading: importLoading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导入 ")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(OioButton), {
            type: "primary",
            onClick: exportDataEvent,
            loading: exportLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          }, 8, ["loading"]),
          (!__props.disabledAddOrDelRow)
            ? (_openBlock(), _createBlock(_unref(OioButton), {
                key: 1,
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (insertEvent(-1)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加下一行")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(OioButton), {
            type: "primary",
            onClick: handleBatchDeleteBtnClick,
            disabled: !selectRecords.value.length||__props.rModel.model.includes('SellerDistributorAuditOrderParam')
          }, {
            default: _withCtx(() => [
              _createTextVNode("批量删除 ")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_unref(OioButton), {
            type: "primary",
            onClick: handleBatchEditBtnClick,
            disabled: !selectRecords.value.length
          }, {
            default: _withCtx(() => [
              _createTextVNode("批量修改 ")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_unref(OioButton), {
            type: "primary",
            onClick: handleBatchEditDiscountClick,
            disabled: !selectRecords.value.length
          }, {
            default: _withCtx(() => [
              _createTextVNode("调整让利归属 ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(OioInput), {
            value: searchStr.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchStr).value = $event)),
            placeholder: "按货号、商品名称、物料号搜索",
            style: {"width":"220px"},
            "allow-clear": ""
          }, null, 8, ["value"]),
          _createElementVNode("span", {
            style: {"font-size":"20px","margin-left":"10px","cursor":"pointer"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(toggleFullscreen) && _unref(toggleFullscreen)(...args)))
          }, [
            (!_unref(isFullscreen))
              ? (_openBlock(), _createBlock(_unref(FullscreenOutlined), { key: 0 }))
              : (_openBlock(), _createBlock(_unref(FullscreenExitOutlined), { key: 1 }))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!__props.disabledFastAddRow)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_unref(OioInput), {
                value: searchVal.value,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchVal).value = $event)),
                onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (queryData(searchVal.value)), ["enter"])),
                placeholder: "请粘贴SAP编码、单位名称、数量",
                style: {"width":"340px"}
              }, null, 8, ["value"]),
              _createVNode(_unref(OioButton), {
                type: "primary",
                loading: addLoading.value,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (queryData(searchVal.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("快速添加")
                ]),
                _: 1
              }, 8, ["loading"])
            ], 64))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(ExclamationCircleOutlined), { style: {"font-size":"16px","color":"var(--oio-error-color)"} }),
          _createElementVNode("span", _hoisted_7, _toDisplayString(tips.value), 1)
        ], 512), [
          [_vShow, tips.value]
        ]),
        _withDirectives(_createVNode(_unref(OioButton), {
          onClick: showErrorModal,
          style: {"color":"red"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 报错信息")
          ]),
          _: 1
        }, 512), [
          [_vShow, errorData.value.length]
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createTextVNode("合计："),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(removeDecimalZero)(__props.formData.actualAmount ?? '0')), 1),
            _createTextVNode("元")
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (__props.isPromotionOrder && __props.formData?.selectGifts?.length)
            ? (_openBlock(), _createBlock(_unref(OioButton), {
                key: 0,
                style: {"margin-left":"auto"},
                type: "primary",
                onClick: openGift
              }, {
                default: _withCtx(() => [
                  _createTextVNode("选择赠品 ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_unref(OioSpin), { loading: tableLoading.value }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_vxe_table, {
              "header-align": "center",
              border: "",
              ref_key: "tableRef",
              ref: tableRef,
              height: "auto",
              "keep-source": "",
              "column-config": { resizable: true },
              data: _unref(paginationDisplayTableData),
              "edit-config": { trigger: 'click', mode: 'cell', beforeEditMethod: beforeEditMethod },
              "scroll-x": { enabled: false },
              "scroll-y": { enabled: true, gt: 0, oSize: 20 },
              "row-config": { height: 80 },
              "cell-class-name": calcCellClassName,
              onCheckboxChange: checkboxChangeEvent,
              onCheckboxAll: checkboxChangeEvent,
              onEditClosed: onEditClosed,
              onEditActived: onEditActived
            }, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_column, {
                  type: "checkbox",
                  fixed: "left",
                  width: "50"
                }),
                _createVNode(_component_vxe_column, {
                  type: "seq",
                  title: "行号",
                  fixed: "left",
                  width: "50"
                }),
                _createVNode(_component_vxe_column, {
                  title: "标签",
                  width: "80"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.isAllocItem)
                      ? (_openBlock(), _createBlock(_unref(OioTag), {
                          key: 0,
                          bordered: false,
                          color: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.isAllocItem ? '分配品' : ''), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (scope.row.isAssemblyItem)
                      ? (_openBlock(), _createBlock(_unref(OioTag), {
                          key: 1,
                          bordered: false,
                          color: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.isAssemblyItem ? '子母件' : ''), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (!isCustomOrder.value)
                  ? (_openBlock(), _createBlock(_component_vxe_column, {
                      key: 0,
                      title: "考核标签",
                      width: "80"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_unref(OioTag), {
                          bordered: false,
                          color: scope.row.isExamine ? 'success' : 'warning'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.isExamine ? '考核' : '不考核'), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_vxe_column, {
                  title: "加购来源",
                  width: "80"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(cartSourceMap[scope.row.addCartSource]), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  title: "ERP商品编码",
                  "min-width": "250"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.outCode)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(scope.row.outCode), 1))
                      : (_openBlock(), _createBlock(_component_a_select, {
                          key: 1,
                          class: "oio-select",
                          "dropdown-class-name": "oio-select-dropdown",
                          getPopupContainer: getPopupContainer,
                          "show-search": "",
                          placeholder: "货号、ERP商品编码、商品名称",
                          style: {"width":"100%"},
                          "default-active-first-option": false,
                          "show-arrow": false,
                          "filter-option": false,
                          "not-found-content": null,
                          options: itemOptions.value,
                          listHeight: 800,
                          dropdownMatchSelectWidth: false,
                          onChange: (outCode) => onSelectItemChange(outCode, scope),
                          onSearch: _unref(onItemSearchDebounce),
                          onBlur: clearItemOptions,
                          onFocus: clearItemOptions
                        }, {
                          dropdownRender: _withCtx(({ menuNode: menu }) => [
                            _createVNode(_unref(OioSpin), {
                              loading: searchLoading.value,
                              onMousedown: _cache[9] || (_cache[9] = (e) => e.preventDefault())
                            }, {
                              default: _withCtx(() => [
                                _createVNode(VNodes, { vnodes: menu }, null, 8, ["vnodes"]),
                                _createElementVNode("div", {
                                  style: {"width":"100%","display":"flex","align-items":"center","justify-content":"space-around","font-size":"16px"},
                                  onMousedown: _cache[8] || (_cache[8] = (e) => e.preventDefault())
                                }, [
                                  _createElementVNode("div", {
                                    style: _normalizeStyle([{"padding":"2px 6px 0"}, _unref(prePageEnabled) ? 'color: #999;cursor: pointer;' : 'color: #DADADA;cursor: not-allowed;'
                          ]),
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (onCurPageChange(-1)))
                                  }, [
                                    _createVNode(_unref(LeftOutlined))
                                  ], 4),
                                  _createElementVNode("div", {
                                    style: _normalizeStyle([{"padding":"2px 6px 0"}, _unref(nextPageEnabled) ? 'color: #999;cursor: pointer;' : 'color: #DADADA;cursor: not-allowed;'
                          ]),
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (onCurPageChange(1)))
                                  }, [
                                    _createVNode(_unref(RightOutlined))
                                  ], 4)
                                ], 32)
                              ]),
                              _: 2
                            }, 1032, ["loading"])
                          ]),
                          _: 2
                        }, 1032, ["options", "onChange", "onSearch"]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemName",
                  title: "商品名称",
                  width: "400"
                }),
                (__props.formData?.orderType==='CUSTOM_MADE')
                  ? (_openBlock(), _createBlock(_component_vxe_column, {
                      key: 1,
                      field: "itemColor",
                      title: "商品颜色",
                      "min-width": "150"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_a_input, {
                          class: "oio-input",
                          value: scope.row.itemColor,
                          "onUpdate:value": ($event: any) => ((scope.row.itemColor) = $event),
                          style: {"width":"110px"}
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_vxe_column, {
                  title: "包装单位",
                  "edit-render": { autofocus: 'input', placeholder: '请点击输入' },
                  width: "300"
                }, {
                  default: _withCtx(({ row, rowIndex }) => [
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(specificationDataListList)[row.uuid], (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "pkg-input-col",
                          key: item.unitCode
                        }, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(item.unitName ?? ''), 1),
                          _createElementVNode("div", _hoisted_17, _toDisplayString(item.count ?? ''), 1),
                          _createElementVNode("div", _hoisted_18, "x" + _toDisplayString(item.pcsCount ?? 0) + "PCS", 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  edit: _withCtx(({ row, rowIndex }) => [
                    _createElementVNode("div", {
                      class: "pkg-col-box",
                      onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (tableRef.value?.clearEdit()), ["self","stop"]))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(specificationDataListList)[row.uuid], (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "pkg-input-col",
                          key: item.unitCode
                        }, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(item.unitName), 1),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_a_input, {
                              value: item.count,
                              onChange: ($event: any) => (handleSpecChange(item, $event)),
                              style: {"width":"100%"},
                              onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (tableRef.value?.clearEdit()), ["enter"]))
                            }, null, 8, ["value", "onChange"])
                          ]),
                          _createElementVNode("div", _hoisted_21, "x" + _toDisplayString(item.pcsCount ?? 0) + "PCS", 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "customerOriginItemNum",
                  title: "客户下单数量",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemNum",
                  title: "下单数量",
                  width: "150",
                  "edit-render": { autofocus: 'input', placeholder: '请点击输入' }
                }, {
                  edit: _withCtx((scope) => [
                    _createVNode(_component_a_input_number, {
                      class: "oio-input-number",
                      value: scope.row.itemNum,
                      "onUpdate:value": ($event: any) => ((scope.row.itemNum) = $event),
                      min: 0,
                      step: 1,
                      style: {"width":"110px"},
                      onKeyup: _cache[12] || (_cache[12] = _withKeys(($event: any) => (tableRef.value?.clearEdit()), ["enter"])),
                      controls: false
                    }, null, 8, ["value", "onUpdate:value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemKarNum",
                  title: "下单件数",
                  "min-width": "150"
                }),
                _createVNode(_component_vxe_column, {
                  title: "价格类型",
                  width: "100"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(_unref(priceTypeEnumMap)[row.priceType]), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "marketUnitPrice",
                  title: "出厂价",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "saleDiscount",
                  title: "特殊扣率",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                (__props.isPromotionOrder)
                  ? (_openBlock(), _createBlock(_component_vxe_column, {
                      key: 2,
                      field: "promotionDeductionRate",
                      title: "活动扣率",
                      width: "100",
                      formatter: _unref(vxeTableRemoveZeroFormatter)
                    }, null, 8, ["formatter"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_vxe_column, {
                  field: "finalSettlementDeductionRate",
                  title: "结算扣率",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                (isCustomOrder.value || isMarketOrder.value)
                  ? (_openBlock(), _createBlock(_component_vxe_column, {
                      key: 3,
                      field: "finalSettlementPrice",
                      title: "结算单价",
                      width: "100",
                      "edit-render": {},
                      formatter: _unref(vxeTableRemoveZeroFormatter)
                    }, {
                      edit: _withCtx((scope) => [
                        _createVNode(_component_a_input_number, {
                          value: scope.row.finalSettlementPrice,
                          "onUpdate:value": ($event: any) => ((scope.row.finalSettlementPrice) = $event),
                          formatter: _unref(removeDecimalZero),
                          class: "oio-input-number num-input",
                          placeholder: "请输入"
                        }, null, 8, ["value", "onUpdate:value", "formatter"])
                      ]),
                      _: 1
                    }, 8, ["formatter"]))
                  : (_openBlock(), _createBlock(_component_vxe_column, {
                      key: 4,
                      field: "finalSettlementPrice",
                      title: "结算单价",
                      width: "100",
                      formatter: _unref(vxeTableRemoveZeroFormatter)
                    }, null, 8, ["formatter"])),
                (__props.isPromotionOrder)
                  ? (_openBlock(), _createBlock(_component_vxe_column, {
                      key: 5,
                      title: "赠品",
                      width: "100"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", null, _toDisplayString(scope.row.isGifted ? '是' : '否'), 1)
                      ]),
                      _: 1
                    }))
                  : (!isCustomOrder.value)
                    ? (_openBlock(), _createBlock(_component_vxe_column, {
                        key: 6,
                        title: "免费",
                        width: "100"
                      }, {
                        default: _withCtx((scope) => [
                          (typeof scope.row.isGifted === 'boolean')
                            ? (_openBlock(), _createBlock(_component_vxe_switch, {
                                key: 0,
                                modelValue: scope.row.isGifted,
                                "onUpdate:modelValue": ($event: any) => ((scope.row.isGifted) = $event),
                                "open-label": "开",
                                "close-label": "关",
                                onChange: ($event: any) => (onChangeRow(scope))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                _createVNode(_component_vxe_column, {
                  field: "freeReasonStr",
                  title: "免费原因",
                  "edit-render": {},
                  width: "140"
                }, {
                  edit: _withCtx((scope) => [
                    (scope.row.isGifted)
                      ? (_openBlock(), _createBlock(_component_a_select, {
                          key: 0,
                          class: "oio-select",
                          "dropdown-class-name": "oio-select-dropdown",
                          getPopupContainer: getPopupContainer,
                          placeholder: "请选择",
                          style: {"width":"100%"},
                          "default-active-first-option": false,
                          options: freeReasonOptions.value,
                          value: scope.row.freeReasonStr,
                          "onUpdate:value": ($event: any) => ((scope.row.freeReasonStr) = $event),
                          onChange: _cache[13] || (_cache[13] = ($event: any) => (__props.setTableEditStatus('CLOSED')))
                        }, null, 8, ["options", "value", "onUpdate:value"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "availableNum",
                  title: "库存",
                  width: "60"
                }),
                _createVNode(_component_vxe_column, {
                  field: "deliAriesInventoryStatusEnum",
                  title: "库存状态",
                  width: "100"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(_unref(inventoryStatusMap)[row.deliAriesInventoryStatusEnum]), 1)
                  ]),
                  _: 1
                }),
                (__props.isPromotionOrder)
                  ? (_openBlock(), _createBlock(_component_vxe_column, {
                      key: 7,
                      title: "活动标签",
                      width: "250"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_22, [
                          (scope.row.prePromotionItem)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, "必定"))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.promotionLablesStr, (label, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              label
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(label), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_vxe_column, {
                  field: "promotionSimpleCodeObj",
                  title: "促销简码",
                  width: "100"
                }, {
                  default: _withCtx((scope) => [
                    (__props.formData?.bizType === 'CHANGE_ORDER' || __props.formData?.orderType === 'REGULAR' || __props.formData?.orderType === 'GIFT')
                      ? (_openBlock(), _createBlock(_component_a_select, {
                          key: 0,
                          class: "oio-select",
                          "dropdown-class-name": "oio-select-dropdown",
                          getPopupContainer: getPopupContainer,
                          placeholder: "请选择",
                          style: {"width":"100%"},
                          "default-active-first-option": false,
                          allowClear: "",
                          options: simpleCodeOptions.value,
                          showSearch: "",
                          optionFilterProp: "label",
                          value: scope.row.promotionSimpleCodeObjId,
                          "onUpdate:value": ($event: any) => ((scope.row.promotionSimpleCodeObjId) = $event),
                          onChange: (val) => onSimpleCodeChange(val, scope.row)
                        }, null, 8, ["options", "value", "onUpdate:value", "onChange"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(scope.row.promotionSimpleCode), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  title: "让利归属",
                  width: "100"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", null, _toDisplayString((scope.row.platformDiscount ? '总部让利'+scope.row.platformDiscount + '%'  : '') +
                (scope.row.provinceDiscount ? '省区让利'+scope.row.provinceDiscount + '%'  : '') + (scope.row.productDiscount ? '产品公司让利'+scope.row.productDiscount + '%'  : '')), 1)
                  ]),
                  _: 1
                }),
                (!__props.isPromotionOrder)
                  ? (_openBlock(), _createBlock(_component_vxe_column, {
                      key: 8,
                      field: "planName",
                      title: "推广方案",
                      width: "400"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_vxe_column, {
                  title: "促销活动",
                  width: "300"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", {
                      id: "TOID-PROMOTION-CELL",
                      title: (
                    scope.row.canDesignShopMatchRules
                      ?.filter((item) => scope.row.calcPromotionIds?.includes?.(item.promotionId))
                      ?.map((item) => item.ruleName) ?? []
                  ).join(';')
                  
                    }, [
                      (scope.row?.canDesignShopMatchRules?.length > 0)
                        ? (_openBlock(), _createBlock(_component_a_select, {
                            key: 0,
                            value: scope.row.canDesignShopMatchRules
                      ?.filter((item) => scope.row.calcPromotionIds?.includes?.(item.promotionId))
                      ?.map((item) => item.ruleName) ?? []
                    ,
                            disabled: __props.isPromotionOrder && scope.row.isGifted,
                            getPopupContainer: getPopupContainer,
                            dropdownClassName: "toid-promotion-dropdown",
                            dropdownMatchSelectWidth: false,
                            open: promotionDropdownOpenMap.value.get(scope.rowid) ?? false,
                            onDropdownVisibleChange: (open) => handlePromotionDropdownVisibleChange(open, scope),
                            mode: "multiple",
                            showSearch: false,
                            maxTagCount: 2,
                            maxTagTextLength: 10
                          }, {
                            dropdownRender: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "promotion-card-container",
                                onMousedown: _cache[14] || (_cache[14] = (e) => e.preventDefault())
                              }, [
                                _createElementVNode("div", _hoisted_27, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promotionDropdownDataList.value, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["promotion-card", {
                            selected: promotionDropdownSelectedDataList.value.some(
                              (item2) => item.promotionId === item2.promotionId
                            ),
                            disabled: _unref(promotionDropdownDisabledDataList).some(
                              (item2) => item.promotionId === item2.promotionId
                            )
                          }]),
                                      key: item.promotionId,
                                      onClick: ($event: any) => (handlePromotionCardClick(item))
                                    }, [
                                      _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("div", _hoisted_30, _toDisplayString(item.ruleName), 1),
                                        _createElementVNode("div", null, [
                                          (item.prePromotionItem)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, "必定"))
                                            : _createCommentVNode("", true),
                                          (item.canSuperposition)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, "可叠加"))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_33, [
                                        (item.planName)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(item.planName) + "-" + _toDisplayString(item.policyName), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 10, _hoisted_28))
                                  }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createVNode(_unref(OioButton), {
                                    style: {"margin-left":"auto"},
                                    onClick: ($event: any) => (promotionDropdownOpenMap.value.set(scope.rowid, false))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 取消 ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_unref(OioButton), {
                                    style: {"margin-left":"10px"},
                                    type: "primary",
                                    onClick: ($event: any) => (handleApplyPromotionBtnClick(scope))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 确认 ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ], 32)
                            ]),
                            _: 2
                          }, 1032, ["value", "disabled", "open", "onDropdownVisibleChange"]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_26)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "policyPromotionType",
                  title: "促销类型",
                  width: "200"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_a_select, {
                      class: "oio-select",
                      "dropdown-class-name": "oio-select-dropdown",
                      value: scope.row.policyPromotionType,
                      "onUpdate:value": ($event: any) => ((scope.row.policyPromotionType) = $event),
                      placeholder: "请选择促销类型",
                      allowClear: "",
                      defaultActiveFirstOption: false,
                      options: __props.baseData.promotionTypeEnumList,
                      disabled: __props.baseData.disabled
                    }, null, 8, ["value", "onUpdate:value", "options", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "actualAmount",
                  title: "结算金额",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "accountTimeRule",
                  title: "记账时间规则",
                  width: "200"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_a_select, {
                      class: "oio-select",
                      "dropdown-class-name": "oio-select-dropdown",
                      getPopupContainer: getPopupContainer,
                      placeholder: "请选择",
                      style: {"width":"100%"},
                      "default-active-first-option": false,
                      allowClear: "",
                      options: timeRuleOptions.value,
                      value: scope.row.accountTimeRule,
                      "onUpdate:value": ($event: any) => ((scope.row.accountTimeRule) = $event),
                      onChange: (val) => onTimeRuleChange(val, scope.row)
                    }, null, 8, ["options", "value", "onUpdate:value", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "paymentDays",
                  title: "指定账期天数",
                  width: "150"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.accountTimeRule === 'DELIVERY_TIME')
                      ? (_openBlock(), _createBlock(_component_a_input_number, {
                          key: 0,
                          min: 1,
                          value: scope.row.paymentDays,
                          "onUpdate:value": ($event: any) => ((scope.row.paymentDays) = $event),
                          class: "oio-input-number num-input",
                          placeholder: "请输入"
                        }, null, 8, ["value", "onUpdate:value"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(scope.row.paymentDays), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "accountDate",
                  title: "指定记账时间",
                  width: "230"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.accountTimeRule === 'TARGET_TIME')
                      ? (_openBlock(), _createBlock(_unref(OioDateTimePicker), {
                          key: 0,
                          value: scope.row.accountDate,
                          "onUpdate:value": ($event: any) => ((scope.row.accountDate) = $event),
                          placeholder: "请选择"
                        }, null, 8, ["value", "onUpdate:value"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(scope.row.accountDate), 1))
                  ]),
                  _: 1
                }),
                (__props.formData.pageType != 'edit')
                  ? (_openBlock(), _createBlock(_component_vxe_column, {
                      key: 9,
                      field: "planName",
                      title: "推广方案",
                      width: "400"
                    }))
                  : _createCommentVNode("", true),
                (__props.formData?.orderType==='CUSTOM_MADE')
                  ? (_openBlock(), _createBlock(_component_vxe_column, {
                      key: 10,
                      field: "materialGroupFour",
                      title: "物料组4",
                      width: "200"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_a_select, {
                          class: "oio-select",
                          "dropdown-class-name": "oio-select-dropdown",
                          getPopupContainer: getPopupContainer,
                          placeholder: "请选择",
                          style: {"width":"100%"},
                          defaultActiveFirstOption: true,
                          allowClear: "",
                          options: materialGroupFourOptions.value,
                          value: scope.row.materialGroupFour,
                          "onUpdate:value": ($event: any) => ((scope.row.materialGroupFour) = $event)
                        }, null, 8, ["options", "value", "onUpdate:value"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_vxe_column, {
                  field: "priceRatio",
                  title: "加价系数",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "customerDiscount",
                  title: "客户扣率",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "specialityDiscount",
                  title: "专业扣率",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "assemblyItemDisplay",
                  title: "关联子件",
                  width: "300",
                  "show-overflow": ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.assemblyItemDisplay), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  title: "操作",
                  fixed: "right",
                  width: "160"
                }, {
                  default: _withCtx((scope) => [
                    (
                  !(__props.isPromotionOrder && scope.row.isGifted) &&
                  (__props.rModel.model.includes('SellerDistributionCreateOrderParam') || scope.row.allowDelete) &&
                  !__props.rModel.model.includes('SellerDistributorAuditOrderParam') &&
                  !__props.disabledAddOrDelRow
                )
                      ? (_openBlock(), _createBlock(_unref(OioButton), {
                          key: 0,
                          type: "link",
                          danger: "",
                          onClick: ($event: any) => (removeRow(scope))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除 ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (
                  __props.isPromotionOrder &&
                  !scope.row?.isGifted &&
                  scope.row?.canDesignShopMatchRules?.length > 1 &&
                  scope.row.canDesignShopMatchRules.some((item) => item?.prePromotionItem)
                )
                      ? (_openBlock(), _createBlock(_unref(OioButton), {
                          key: 1,
                          type: "link",
                          style: {"margin-left":"4px"},
                          onClick: ($event: any) => (openSplitModal(scope))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("必定拆分 ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (scope.row.outCode)
                      ? (_openBlock(), _createBlock(_unref(OioButton), {
                          key: 2,
                          type: "link",
                          style: {"margin-left":"4px"},
                          onClick: ($event: any) => (viewStorage(scope))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查看库存 ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "edit-config"])
          ]),
          _createVNode(_unref(OioPagination), {
            style: {"margin-top":"12px"},
            currentPage: displayTablePagination.current,
            "onUpdate:currentPage": _cache[15] || (_cache[15] = ($event: any) => ((displayTablePagination.current) = $event)),
            pageSize: displayTablePagination.pageSize,
            "onUpdate:pageSize": _cache[16] || (_cache[16] = ($event: any) => ((displayTablePagination.pageSize) = $event)),
            total: displayTableData.value?.length,
            pageSizes: [15, 20, 30, 50, 100],
            showTotal: (total) => `${total} 条`
          }, null, 8, ["currentPage", "pageSize", "total", "showTotal"])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode(_unref(OioModal), {
      visible: errorModal.value,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((errorModal).value = $event)),
      title: "提示信息",
      width: 600,
      "get-trigger-container": getModalContainer
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _createTextVNode(" 成功 "),
          _createElementVNode("span", _hoisted_38, _toDisplayString(dataSource.value.length), 1),
          _createTextVNode(" 条，失败 "),
          _createElementVNode("span", _hoisted_39, _toDisplayString(errorData.value.length), 1),
          _createTextVNode(" 条 ")
        ]),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createVNode(_unref(OioButton), {
            style: {"margin-left":"auto"},
            type: "primary",
            onClick: downloadErrorfile
          }, {
            default: _withCtx(() => [
              _createTextVNode("下载")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_vxe_table, {
          "header-align": "center",
          border: "",
          data: errorData.value,
          "max-height": 400,
          ref_key: "errorTableRef",
          ref: errorTableRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vxe_column, {
              type: "seq",
              width: "60"
            }),
            _createVNode(_component_vxe_column, {
              field: "msg",
              title: "提示信息"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_drawer, {
      class: "toid-gift-drawer oio-drawer",
      visible: __props.state.showGiftDrawer,
      "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((__props.state.showGiftDrawer) = $event)),
      title: "选择赠品",
      width: 552,
      getContainer: getModalContainer,
      onClose: _cache[21] || (_cache[21] = ($event: any) => (__props.state.showGiftDrawer = false))
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: onGiftDrawerConfirm,
          loading: confirmBtnLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_unref(OioButton), {
          onClick: _cache[19] || (_cache[19] = ($event: any) => (__props.state.showGiftDrawer = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("关闭")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_radio_group, {
          class: "active-swiper",
          value: __props.state.selectedActivePromotionId,
          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((__props.state.selectedActivePromotionId) = $event)),
          "button-style": "solid"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mergedDataListMap).entries(), ([id, itemArr]) => {
              return (_openBlock(), _createBlock(_component_a_radio_button, {
                key: id,
                value: id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(itemArr[0].promotionName), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"]),
        _createElementVNode("div", _hoisted_42, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedActive), (active, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (active?.giftMatchDesc)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createVNode(_unref(TagFilled)),
                    _createElementVNode("span", _hoisted_44, _toDisplayString(active?.giftMatchDesc), 1)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(active?.selectGifts ?? [], (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "gift-item",
                  key: item.itemId
                }, [
                  _createElementVNode("img", {
                    src: item.itemPicUrl,
                    alt: "",
                    class: "gift-img"
                  }, null, 8, _hoisted_45),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("span", _hoisted_47, _toDisplayString(item.itemName), 1),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("span", null, "* " + _toDisplayString(item.giftDesc), 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _hoisted_51,
                      _createElementVNode("span", _hoisted_52, "¥" + _toDisplayString(item.itemUnitPrice), 1)
                    ]),
                    _createVNode(_component_a_input_number, {
                      class: "oio-input-number num-input",
                      disabled: !active.isUseSelect,
                      value: item.itemNum,
                      "onUpdate:value": ($event: any) => ((item.itemNum) = $event),
                      min: 0,
                      max: item.itemNum + calcRemainItemNum(active),
                      step: 1,
                      precision: 0
                    }, null, 8, ["disabled", "value", "onUpdate:value", "max"])
                  ])
                ]))
              }), 128))
            ], 64))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(OioModal), {
      visible: batchEditModalVisible.value,
      "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((batchEditModalVisible).value = $event)),
      title: "批量修改",
      width: "medium"
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          onClick: _cache[22] || (_cache[22] = ($event: any) => (batchEditModalVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: onSubmitBatchEdit
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editModalDataList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "edit-row",
            key: item.id
          }, [
            _hoisted_53,
            _createElementVNode("div", _hoisted_54, [
              _createVNode(_component_a_select, {
                class: "oio-select",
                "dropdown-class-name": "oio-select-dropdown",
                value: item.type,
                "onUpdate:value": ($event: any) => ((item.type) = $event),
                placeholder: "请选择",
                style: {"width":"100%"},
                "default-active-first-option": false,
                options: _unref(displayEditTypeOptions),
                getPopupContainer: getPopupContainer
              }, null, 8, ["value", "onUpdate:value", "options"])
            ]),
            _hoisted_55,
            _createElementVNode("div", _hoisted_56, [
              (item.type && ['isExamine'].includes(item.type))
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 0,
                    class: "oio-select",
                    "dropdown-class-name": "oio-select-dropdown",
                    value: item.value,
                    "onUpdate:value": ($event: any) => ((item.value) = $event),
                    placeholder: "不修改",
                    style: {"width":"100%"},
                    "default-active-first-option": false,
                    allowClear: true,
                    options: [
              {
                label: '不考核',
                value: false
              },
              {
                label: '考核',
                value: true
              }
            ]
                  }, null, 8, ["value", "onUpdate:value"]))
                : (item.type && ['isGifted'].includes(item.type))
                  ? (_openBlock(), _createBlock(_component_a_select, {
                      key: 1,
                      class: "oio-select",
                      "dropdown-class-name": "oio-select-dropdown",
                      value: item.value,
                      "onUpdate:value": ($event: any) => ((item.value) = $event),
                      placeholder: "不修改",
                      style: {"width":"100%"},
                      "default-active-first-option": false,
                      allowClear: true,
                      disabled: __props.isPromotionOrder,
                      options: [
              {
                label: '免费',
                value: true
              },
              {
                label: '不免费',
                value: false
              }
            ]
                    }, null, 8, ["value", "onUpdate:value", "disabled"]))
                  : (item.type && ['accountTimeRule'].includes(item.type))
                    ? (_openBlock(), _createBlock(_component_a_select, {
                        key: 2,
                        class: "oio-select",
                        "dropdown-class-name": "oio-select-dropdown",
                        getPopupContainer: getPopupContainer,
                        placeholder: "不修改",
                        style: {"width":"100%"},
                        "default-active-first-option": false,
                        options: timeRuleOptions.value,
                        value: item.value,
                        "onUpdate:value": ($event: any) => ((item.value) = $event)
                      }, null, 8, ["options", "value", "onUpdate:value"]))
                    : (item.type && ['paymentDays'].includes(item.type))
                      ? (_openBlock(), _createBlock(_component_a_input_number, {
                          key: 3,
                          value: item.value,
                          "onUpdate:value": ($event: any) => ((item.value) = $event),
                          class: "oio-input-number num-input",
                          placeholder: "不修改"
                        }, null, 8, ["value", "onUpdate:value"]))
                      : (item.type && ['promotionSimpleCode'].includes(item.type))
                        ? (_openBlock(), _createBlock(_component_a_select, {
                            key: 4,
                            class: "oio-select",
                            "dropdown-class-name": "oio-select-dropdown",
                            getPopupContainer: getPopupContainer,
                            placeholder: "不修改",
                            style: {"width":"100%"},
                            "default-active-first-option": false,
                            options: simpleCodeOptions.value,
                            showSearch: "",
                            optionFilterProp: "label",
                            value: item.value,
                            "onUpdate:value": ($event: any) => ((item.value) = $event)
                          }, null, 8, ["options", "value", "onUpdate:value"]))
                        : (item.type && ['accountDate'].includes(item.type))
                          ? (_openBlock(), _createBlock(_unref(OioDateTimePicker), {
                              key: 5,
                              value: item.value,
                              "onUpdate:value": ($event: any) => ((item.value) = $event),
                              placeholder: "不修改"
                            }, null, 8, ["value", "onUpdate:value"]))
                          : (item.type && ['freeReasonStr'].includes(item.type))
                            ? (_openBlock(), _createBlock(_component_a_select, {
                                key: 6,
                                class: "oio-select",
                                "dropdown-class-name": "oio-select-dropdown",
                                getPopupContainer: getPopupContainer,
                                placeholder: "不修改",
                                style: {"width":"100%"},
                                "default-active-first-option": false,
                                options: freeReasonOptions.value,
                                value: item.value,
                                "onUpdate:value": ($event: any) => ((item.value) = $event)
                              }, null, 8, ["options", "value", "onUpdate:value"]))
                            : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_57, [
              _withDirectives(_createVNode(_unref(MinusCircleOutlined), {
                onClick: ($event: any) => (removeEditModalRow(item.id))
              }, null, 8, ["onClick"]), [
                [_vShow, editModalDataList.value.length > 1]
              ]),
              _withDirectives(_createVNode(_unref(PlusCircleOutlined), { onClick: addEditModalRow }, null, 512), [
                [_vShow, index === editModalDataList.value.length - 1 && index !== _unref(displayEditTypeOptions).length - 1]
              ])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(OioModal), {
      visible: batchDiscountModalVisible.value,
      "onUpdate:visible": _cache[28] || (_cache[28] = ($event: any) => ((batchDiscountModalVisible).value = $event)),
      title: "调整让利归属",
      width: "medium"
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          onClick: _cache[27] || (_cache[27] = ($event: any) => (batchDiscountModalVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: onSubmitBatchEditDiscount
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_58, [
          _createVNode(_unref(OioForm), { data: discountForm.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(OioRow), { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(OioCol), { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(OioFormItem), {
                        name: "platformDiscount",
                        label: "总部让利",
                        rules: [{ validator: validatePlatformDiscount, trigger: 'blur' }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OioInput), {
                            value: discountForm.value.platformDiscount,
                            "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((discountForm.value.platformDiscount) = $event)),
                            placeholder: "",
                            suffix: "%"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(OioCol), { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(OioFormItem), {
                        name: "provinceDiscount",
                        label: "省区让利",
                        rules: [{ validator: validateProvinceDiscount, trigger: 'blur' }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OioInput), {
                            value: discountForm.value.provinceDiscount,
                            "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((discountForm.value.provinceDiscount) = $event)),
                            placeholder: "",
                            suffix: "%"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(OioCol), { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(OioFormItem), {
                        name: "productDiscount",
                        label: "产品公司让利",
                        rules: [{ validator: validateProductDiscount, trigger: 'blur' }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OioInput), {
                            value: discountForm.value.productDiscount,
                            "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((discountForm.value.productDiscount) = $event)),
                            placeholder: "",
                            suffix: "%"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(OioModal), {
      class: "toid-split-modal",
      visible: splitModalVisible.value,
      "onUpdate:visible": _cache[34] || (_cache[34] = ($event: any) => ((splitModalVisible).value = $event)),
      title: "必定拆分",
      width: "medium"
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          onClick: _cache[33] || (_cache[33] = ($event: any) => (splitModalVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: handleSplitModalConfirmBtnClick
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _createElementVNode("span", _hoisted_62, _toDisplayString(splitModalOpenSource.value?.outCode ?? ''), 1)
          ]),
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _createElementVNode("span", _hoisted_65, _toDisplayString(splitModalOpenSource.value?.itemName ?? ''), 1)
          ]),
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                (splitModalOpenSource.value?.prePromotionItem)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_70, "必定"))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(splitModalOpenSource.value?.promotionLablesStr ?? [], (label, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    label
                      ? (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(label), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ])
          ])
        ]),
        _createVNode(_component_a_divider, { style: {"margin":"24px 0 12px 0"} }),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createVNode(_unref(OioButton), {
              type: "primary",
              onClick: _cache[29] || (_cache[29] = ($event: any) => (splitInsertEvent(-1)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加下一行")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_74, [
              _createTextVNode(" 合计： "),
              _createElementVNode("span", _hoisted_75, _toDisplayString(_unref(splitTotalItemNum)), 1),
              _hoisted_76
            ])
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createVNode(_component_vxe_table, {
              "header-align": "center",
              border: "",
              ref_key: "splitTableRef",
              ref: splitTableRef,
              height: "auto",
              "keep-source": "",
              "column-config": { resizable: true },
              data: splitModalDataSource.value,
              "scroll-y": { enabled: true, gt: 0, oSize: 20 },
              "row-config": { height: 80 }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_column, {
                  type: "seq",
                  title: "行号",
                  fixed: "left",
                  width: "50"
                }),
                _createVNode(_component_vxe_column, {
                  title: "促销活动",
                  "min-width": "300"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_78, [
                      _createVNode(_component_a_select, {
                        value: scope.row.canDesignShopMatchRules
                      ?.filter((item) => scope.row.calcPromotionIds?.includes?.(item.promotionId))
                      ?.map((item) => item.ruleName) ?? []
                    ,
                        disabled: __props.isPromotionOrder && scope.row.isGifted,
                        getPopupContainer: getSplitModalPopupContainer,
                        dropdownClassName: "toid-promotion-dropdown",
                        dropdownMatchSelectWidth: false,
                        open: splitPromotionDropdownOpenMap.value.get(scope.rowid) ?? false,
                        onDropdownVisibleChange: (open) => handleSplitPromotionDropdownVisibleChange(open, scope),
                        showSearch: false,
                        maxTagCount: 2,
                        maxTagTextLength: 10,
                        style: {"width":"100%"}
                      }, {
                        dropdownRender: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "promotion-card-container",
                            onMousedown: _cache[30] || (_cache[30] = (e) => e.preventDefault())
                          }, [
                            _createElementVNode("div", _hoisted_79, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(splitPromotionDropdownDataList.value, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(["promotion-card", {
                            selected: splitPromotionDropdownSelectedDataList.value.some(
                              (item2) => item.promotionId === item2.promotionId
                            ),
                            disabled: _unref(splitPromotionDropdownDisabledDataList).some(
                              (item2) => item.promotionId === item2.promotionId
                            )
                          }]),
                                  key: item.promotionId,
                                  onClick: ($event: any) => (handleSplitPromotionCardClick(item))
                                }, [
                                  _createElementVNode("div", _hoisted_81, [
                                    _createElementVNode("div", _hoisted_82, _toDisplayString(item.ruleName), 1),
                                    _createElementVNode("div", null, [
                                      (item.prePromotionItem)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_83, "必定"))
                                        : _createCommentVNode("", true),
                                      (item.canSuperposition)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_84, "可叠加"))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_85, [
                                    (item.planName)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(item.planName) + "-" + _toDisplayString(item.policyName), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 10, _hoisted_80))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_87, [
                              _createVNode(_unref(OioButton), {
                                style: {"margin-left":"auto"},
                                onClick: ($event: any) => (splitPromotionDropdownOpenMap.value.set(scope.rowid, false))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 取消 ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_unref(OioButton), {
                                style: {"margin-left":"10px"},
                                type: "primary",
                                onClick: ($event: any) => (handleSplitApplyPromotionBtnClick(scope))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 确认 ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ], 32)
                        ]),
                        _: 2
                      }, 1032, ["value", "disabled", "open", "onDropdownVisibleChange"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  title: "包装单位",
                  "min-width": "300"
                }, {
                  default: _withCtx(({ row, rowIndex }) => [
                    _createElementVNode("div", _hoisted_88, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(splitSpecificationDataListList)[rowIndex], (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "pkg-input-col",
                          key: item.unitCode
                        }, [
                          _createElementVNode("div", _hoisted_89, _toDisplayString(item.unitName), 1),
                          _createElementVNode("div", _hoisted_90, [
                            _createVNode(_component_a_input, {
                              value: item.count,
                              onChange: (e) => (item.count = Number(String(e.target.value).replace(/[^0-9]/g, ''))),
                              style: {"width":"100%"},
                              onBlur: ($event: any) => (_unref(onSplitSpecChange)(row.uuid)),
                              onKeyup: _cache[31] || (_cache[31] = _withKeys(($event: any) => (tableRef.value?.clearEdit()), ["enter"]))
                            }, null, 8, ["value", "onChange", "onBlur"])
                          ]),
                          _createElementVNode("div", _hoisted_91, "x" + _toDisplayString(item.pcsCount ?? 0) + "PCS", 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemNum",
                  title: "下单数量",
                  "min-width": "150",
                  "edit-render": { autofocus: 'input', placeholder: '请点击输入' }
                }, {
                  edit: _withCtx((scope) => [
                    _createVNode(_component_a_input_number, {
                      class: "oio-input-number",
                      value: scope.row.itemNum,
                      "onUpdate:value": ($event: any) => ((scope.row.itemNum) = $event),
                      min: 0,
                      step: 1,
                      style: {"width":"110px"},
                      onKeyup: _cache[32] || (_cache[32] = _withKeys(($event: any) => (tableRef.value?.clearEdit()), ["enter"])),
                      controls: false
                    }, null, 8, ["value", "onUpdate:value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  title: "操作",
                  fixed: "right",
                  width: "80"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_unref(OioButton), {
                      type: "link",
                      onClick: ($event: any) => (removeSplitRow(scope))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(StoreDialog, {
      visible: storeDialogVisible.value,
      "onUpdate:visible": _cache[35] || (_cache[35] = ($event: any) => ((storeDialogVisible).value = $event)),
      info: storeRow.value,
      sellerPartnerId: __props.formData.seller?.id,
      bizType: __props.formData.bizType,
      ariesIssuingMethodEnum: __props.formData.ariesIssuingMethodEnum,
      rModel: __props.rModel,
      salesOfficeId: __props.formData.salesOffice?.id,
      buyerPartnerId: __props.formData.buyer?.id
    }, null, 8, ["visible", "info", "sellerPartnerId", "bizType", "ariesIssuingMethodEnum", "rModel", "salesOfficeId", "buyerPartnerId"])
  ], 512))
}
}

})